module.exports = __webpack_public_path__ + "static/fab-fa3ad825817eb3f28eb7a85ca82fdd58.png";